import stepUpPrompt from "@/shared/stepUpPrompt";

/**
 * Rejecting with this marks a user-cancelled / blocked step-up. ErrorResolver
 * recognizes the `stepUpCancelled` flag and stays silent (no error toast).
 */
export const STEP_UP_CANCELLED = { stepUpCancelled: true };

/**
 * Wrap an async API fn so it requires a (windowed) step-up before running.
 * @param {Function} fn the underlying API call
 * @param {string} method verification method (default 'totp')
 * @returns {Function} guarded fn with the same arguments
 */
export function stepUpGuard(fn, method = "totp") {
  return async (...args) => {
    const ok = await stepUpPrompt.ensureVerified(method);
    if (!ok) return Promise.reject(STEP_UP_CANCELLED);
    return fn(...args);
  };
}

export default stepUpGuard;
